import { createAction } from '../../utils/redux-helper';
import * as ActionDefinitions from './actionDefinitions';

export const setIsLogged = () => {
  return createAction(ActionDefinitions.SET_IS_LOGGED);
};
